export default "__VITE_ASSET__8148342c__"